import { executeRestAPICall } from "../services/generic.service";
import { CourseProgress } from "./course-progress.types";

const COURSE_PROGRESS_API = `${process.env.REACT_APP_LTI_BACKEND_API}/lti/course-progresses`;

async function getCourseProgress(courseId: number): Promise<CourseProgress> {
  const courseProgress: CourseProgress = await executeRestAPICall({
    method: "GET",
    url: `${COURSE_PROGRESS_API}/${courseId}`,
  });
  return courseProgress;
}

async function getMultipleCourseProgresses(
  courseIds: number[],
): Promise<[number, CourseProgress | null][]> {
  const progresses = await executeRestAPICall({
    method: "GET",
    url: `${COURSE_PROGRESS_API}/many/${courseIds.join(",")}`,
    data: courseIds,
  });
  return progresses;
}

async function createParentCourseProgress(courseId: number) {
  await executeRestAPICall({
    method: "POST",
    url: `${COURSE_PROGRESS_API}/create-parent/${courseId}`,
  });
}

async function createCourseProgress(courseId: number) {
  await executeRestAPICall({
    method: "POST",
    url: `${COURSE_PROGRESS_API}/${courseId}`,
  });
}

async function updateCourseProgress(courseId: number, data: CourseProgress) {
  await executeRestAPICall({
    method: "PUT",
    url: `${COURSE_PROGRESS_API}/${courseId}`,
    data,
  });
}

async function cascadeCourseProgressUpdate(
  courseId: number,
  data: CourseProgress,
) {
  await executeRestAPICall({
    method: "PUT",
    url: `${COURSE_PROGRESS_API}/cascade/${courseId}`,
    data,
  });
}

export {
  getCourseProgress,
  getMultipleCourseProgresses,
  createCourseProgress,
  updateCourseProgress,
  createParentCourseProgress,
  cascadeCourseProgressUpdate,
};
